import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers";
import * as React from "react";
import { useCardTableContext } from "../../../context/CardTableContext";

export const CollapseAll = () => {
  const { table } = useCardTableContext();

  return (
    <OverlayTrigger
      overlay={
        <Tooltip id="budgets-collapse-tooltip">
          <FormattedMessage id="TOOLTIP.COLLAPSE_ALL" />
        </Tooltip>
      }
    >
      <button
        type="button"
        className="btn btn-icon btn-light-secondary mr-3"
        onClick={() => table.toggleAllRowsExpanded(false)}
      >
        <span className="svg-icon svg-icon-md svg-icon-primary">
          <SVG src={toAbsoluteUrl("/media/svg/icons/General/Scale.svg")} />
        </span>
      </button>
    </OverlayTrigger>
  );
};
